import { HvlMapConverter } from '@hvlng/framework-bff/util';
import { EmptyControl, HvlBaseModel, MaxLength, NotBlank } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { DiscriminatorDefinitionDetailModel } from './discriminator-definition-detail-model';

@JsonObject('KovanHrDiscriminatorDefinitionModel')
export class DiscriminatorDefinitionModel extends HvlBaseModel {
    @MaxLength(25)
    @NotBlank()
    @JsonProperty('code', String, true)
    code: string = null;

    @EmptyControl()
    @JsonProperty('discriminatorGroup', String, true)
    discriminatorGroup: string = null;

    @JsonProperty('detailMap', HvlMapConverter, true)
    detailMap: Map<string, DiscriminatorDefinitionDetailModel> = new Map<string, DiscriminatorDefinitionDetailModel>();

    @MaxLength(50)
    @JsonProperty('shortText', String, true)
    shortText: string = null;

    @MaxLength(250)
    @JsonProperty('longText', String, true)
    longText: string = null;
}
